export const JiraFieldKey: Record<Jira.FieldKey, string> = {
  Summary: "summary",
  Description: "description",
  Labels: "labels",
  IssueType: "issuetype",
  Project: "project",
  Reporter: "reporter",
  Priority: "priority"
} as const
